var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({ref:"editor",staticClass:"viewer__image-editor"},'div',_vm.themeDataAttr,false))
}
var staticRenderFns = []

export { render, staticRenderFns }